import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import Iconify from 'src/components/iconify/Iconify';
import { Stack, padding } from '@mui/system';
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import { createOdooURL } from '../../routes/odooURL';

export default function ApplicationsPage() {
  const { translate } = useLocales();

  type IconifyIcon = string;

  interface CardData {
    icon: IconifyIcon;
    title: string;
    description: string;
    url?: string;
  }

  const cardsVente: CardData[] = [
    {
      icon: 'mdi:account-group', // Icône représentant des utilisateurs ou des clients
      title: `${translate('upComingAppsPage.sale.CRM.title')}`,
      description: `${translate('upComingAppsPage.sale.CRM.description')}`,
      url: createOdooURL('crm'),
    },
    {
      icon: 'mdi:cash-register', // Icône représentant une caisse enregistreuse ou des transactions financières
      title: `${translate('upComingAppsPage.sale.sales.title')}`,
      description: `${translate('upComingAppsPage.sale.sales.description')}`,
      url: createOdooURL('sales'),
    },
    {
      icon: 'mdi:store', // Icône représentant un magasin ou un point de vente
      title: `${translate('upComingAppsPage.sale.POS.title')}`,
      description: `${translate('upComingAppsPage.sale.POS.description')}`,
      url: createOdooURL('pos'),
    },
    {
      icon: 'mdi:credit-card-multiple', // Icône représentant des abonnements ou des paiements récurrents
      title: `${translate('upComingAppsPage.sale.subscription.title')}`,
      description: `${translate(
        'upComingAppsPage.sale.subscription.description'
      )}`,
      url: createOdooURL('subscription'),
    },
    {
      icon: 'mdi:truck-delivery', // Icône représentant des livraisons
      title: `${translate('upComingAppsPage.sale.rental.title')}`,
      description: `${translate('upComingAppsPage.sale.rental.description')}`,
      url: createOdooURL('rental'),
    },
  ];

  return (
    <>
      <Helmet>
        <title> {`${translate('upComingAppsPage.title')}`} </title>
      </Helmet>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Typography
            variant="h3"
            paragraph
            align="center"
            sx={{ marginTop: '70px', marginBottom: '100px' }}
          >
            {`${translate('upComingAppsPage.appList')}`}
          </Typography>

          <Grid container spacing={12} sx={{ maxWidth: '1000px' }}>

            <Grid item>
              <Typography variant="h4" paragraph>
                {`${translate('upComingAppsPage.sale.title')}`}
              </Typography>

              <Typography sx={{ marginBottom: '20px' }}>
                {`${translate('upComingAppsPage.sale.description')}`}
              </Typography>

              <Grid container spacing={2}>
                {cardsVente.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardActionArea
                        component="a"
                        href={card.url}
                        target="_bank"
                      >
                        <CardContent
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <div>
                            <Icon
                              icon={card.icon}
                              width={32}
                              style={{ marginRight: 16 }}
                            />
                          </div>
                          <div>
                            <Typography variant="h6">{card.title}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {card.description}
                            </Typography>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Typography variant="h4" sx={{ marginTop: '80px' }} align="center">
            {`${translate('upComingAppsPage.footer.line1')}`} <br />
            {`${translate('upComingAppsPage.footer.line2')}`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
